import { useUpdateEffect } from 'ahooks';
import { useEffect, useState, useRef, useCallback } from 'react'
import useService from '../view/lanhu_4/service';

export default function usePlayer() {

    const cacheStudyTime = 10;                                          // 每隔指定时间(单位/秒)保存观看记录
    const fiberStudyTime = useRef(0);                                   // 每段学习时间

    const time = useRef({
        duration: 0,                                                    // 视频时间总长
        total: 0,                                                       // 视频剩余时间总长
        pause: 0                                                        // 播放器最新从播放到暂停时间
    });
    const updateRecordCache = useRef(1);                                // 第N次(N * cacheStudyTime/秒)缓存观看记录
    const [startFlag, setStartFlag] = useState(false)                   // 视频开始状态
    const [pauseFlag, setPauseFlag] = useState(false);                  // 视频暂停状态
    const [endFlag, setEndFlag] = useState(false);                      // 视频播放完状态
    const timer = useRef(null);                                         // 定时器

    const { record, recordUpdate } = useService();

    const minus = useCallback(() => {
        timer.current = setInterval(() => {
            if (record === '100') {
                return
            }
            time.current.total--;
            fiberStudyTime.current++;
            // console.log(time.current.duration, updateRecordCache.current * cacheStudyTime + time.current.total + record / 100 * time.current.duration)
            //缓存观看学习进度
            // if (time.current.duration >= updateRecordCache.current * cacheStudyTime + time.current.total + record / 100 * time.current.duration) {
            if (fiberStudyTime.current === cacheStudyTime) {
                fiberStudyTime.current = 0;
                const cacheTime = updateRecordCache.current * cacheStudyTime;
                const recordTime = record / 100 * time.current.duration;
                const updateTime = cacheTime + recordTime;
                let rd = Math.ceil(updateTime / time.current.duration * 100)
                if (rd.toString() === 'NaN') {
                    rd = 100;
                }
                recordUpdate(rd)
                updateRecordCache.current++;
            }
            // }
            console.log(time)
            // 视频看完
            if (time.current.total < 1) {
                clearInterval(timer.current)
                setEndFlag(true)
                recordUpdate(100)
            }
        }, 1000)
    }, [record])

    useUpdateEffect(() => {
        if (!pauseFlag) {
            // 恢复播放器继续看
            minus()
        } else {
            // 播放器暂停
            clearInterval(timer.current)
        }
    }, [pauseFlag])

    useUpdateEffect(() => {
        if (record === '100') {
            // 已经看完了直接结束
            return
        }
        // 开始
        if (time.current.total > 0 && startFlag) {
            minus()
        }
        return () => {
            clearInterval(timer.current)
        }
    }, [startFlag])

    return {
        endFlag,
        pauseFlag,
        setStartFlag,
        setPauseFlag,
        time,
    }

}
